import { combineReducers } from 'redux'
import identity from './slices/identitySlice'
import billing from './slices/billingSlice'
import helpdesk from './slices/helpdeskSlice'
import vps from './slices/vpsSlice'
import theme from './slices/themeSlice'
import stats from './slices/statsSlice'
import reverseProxy from './slices/reverseProxySlice'
import domain from './slices/domainSlice'
import dns from './slices/dnsSlice'
import email from './slices/emailSlice'
import automation from './slices/automationSlice'

const rootReducer = asyncReducers => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth: identity,
    billing,
    helpdesk,
    vps,
    stats,
    domain,
    dns,
    email,
    reverseProxy,
    automation,
    ...asyncReducers,
  })

  return combinedReducer(state, action)
}

export default rootReducer
